import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelPaperConsult } from "../../functions/Report.ExportPaper";
import { formatDataPaper } from "../../utils/Report.Format";
import { FilterYearType } from "../common/ReportFilters";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
} from "../../../../utils/useStyle";

const initialData = {
  jan: { adult: 0, kid: 0 },
  feb: { adult: 0, kid: 0 },
  mar: { adult: 0, kid: 0 },
  apr: { adult: 0, kid: 0 },
  may: { adult: 0, kid: 0 },
  jun: { adult: 0, kid: 0 },
  jul: { adult: 0, kid: 0 },
  aug: { adult: 0, kid: 0 },
  sep: { adult: 0, kid: 0 },
  oct: { adult: 0, kid: 0 },
  nov: { adult: 0, kid: 0 },
  dec: { adult: 0, kid: 0 },
};

const ReportCountConsultPaper = ({ userDept }) => {
  const [loading, setLoading] = React.useState("");
  const [year, setYear] = React.useState({ label: "ทุกปี", value: "ALL" });
  const [type, setType] = React.useState({ label: "-", value: "NONE" });
  const [data, setData] = React.useState(initialData);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getConsultPapersReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching consult papers report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const listTable = [
    { name: "ม.ค.", child: data?.jan?.kid, adult: data?.jan?.adult },
    { name: "ก.พ.", child: data?.feb?.kid, adult: data?.feb?.adult },
    { name: "มี.ค.", child: data?.mar?.kid, adult: data?.mar?.adult },
    { name: "เม.ย.", child: data?.apr?.kid, adult: data?.apr?.adult },
    { name: "พ.ค.", child: data?.may?.kid, adult: data?.may?.adult },
    { name: "มิ.ย.", child: data?.jun?.kid, adult: data?.jun?.adult },
    { name: "ก.ค.", child: data?.jul?.kid, adult: data?.jul?.adult },
    { name: "ส.ค.", child: data?.aug?.kid, adult: data?.aug?.adult },
    { name: "ก.ย.", child: data?.sep?.kid, adult: data?.sep?.adult },
    { name: "ต.ค.", child: data?.oct?.kid, adult: data?.oct?.adult },
    { name: "พ.ย.", child: data?.nov?.kid, adult: data?.nov?.adult },
    { name: "ธ.ค.", child: data?.dec?.kid, adult: data?.dec?.adult },
  ];

  return (
    <div className="my-20">
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          จำนวนใบปรึกษาที่ได้รับทั้งหมดต่อปี
          <div className={STYLEBODY}>
            แยกตามเดือน แยกเป็น เด็ก (ต่ำกว่า 18ปี) ผู้ใหญ่ (18 ปีขึ้นไป) ของปี
            "{year.label}" ประเภทสาย "{type.label}"
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearType
            year={year}
            setYear={setYear}
            type={type}
            setType={setType}
          />
          <ButtonExcel
            text={"DOWNLOAD EXCEL"}
            onClick={() => {
              ExcelPaperConsult(formatDataPaper(data), year, type, setLoading);
            }}
            loading={loading}
          />
        </div>
      </div>
      <div className={BARCHART}>
        <BarChart
          width={700}
          height={300}
          data={listTable}
          margin={{ top: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar label={{ fill: "#111827" }} dataKey="child" fill="#fda4af" />
          <Bar label={{ fill: "#111827" }} dataKey="adult" fill="#fecdd3" />
        </BarChart>
      </div>
    </div>
  );
};

export default ReportCountConsultPaper;
